import { render, staticRenderFns } from "./WidgetsDashboardKpi.vue?vue&type=template&id=b831b4b0&scoped=true"
import script from "./WidgetsDashboardKpi.vue?vue&type=script&lang=js"
export * from "./WidgetsDashboardKpi.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDashboardKpi.vue?vue&type=style&index=0&id=b831b4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b831b4b0",
  null
  
)

export default component.exports